var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4029 17.5C14.2778 17.5 14.152 17.4707 14.0364 17.4106L9.99961 15.3024L5.96365 17.4106C5.69606 17.5491 5.37306 17.5253 5.13081 17.3481C4.88697 17.1708 4.76584 16.8709 4.8173 16.5741L5.58602 12.1204L2.32431 8.9669C2.10739 8.75719 2.02902 8.44223 2.12164 8.15418C2.21427 7.86771 2.46206 7.65801 2.76132 7.61527L7.27387 6.96004L9.29106 2.90359C9.55865 2.36547 10.4414 2.36547 10.709 2.90359L12.7261 6.96004L17.2387 7.61527C17.538 7.65801 17.7858 7.86771 17.8784 8.15418C17.971 8.44223 17.8926 8.75719 17.6757 8.9669L14.414 12.1204L15.1827 16.5741C15.2342 16.8709 15.1123 17.1708 14.8692 17.3481C14.7315 17.4494 14.5676 17.5 14.4029 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationStar);
export default __webpack_public_path__ + "static/media/notificationStar.d7d6de8ae7b25fc3f24f29ab61588225.svg";
export { ForwardRef as ReactComponent };